var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{staticStyle:{"border-radius":"10px"}},[_c('v-card-title',{staticStyle:{"color":"#595959"}},[_c('v-row',[_c('v-col',{staticClass:"py-2"},[_vm._v(_vm._s('Hoşgeldiniz ' + this.$store.state.FullName))])],1)],1),_c('v-divider'),_c('v-card-text',{staticClass:"pt-4"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }